import { Layout, Flex, Button } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import { NewspaperFolding, VolumeSmall } from '@icon-park/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { REQUEST_URL } from '../../utils/env';
import { useNavigate } from 'react-router-dom';

const { Header, Footer, Content } = Layout;

function IndexMy() {

    const navigate = useNavigate();

    const toGo = (page) => {
        window.scrollTo(0, 0);
        navigate(page)
    }

    const [sytj, setSytj] = useState()

    const getSYTJ = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/index/getSYTJ',
            )
            setSytj(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [jckb, setJcbk] = useState()
    const getJCKB = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/index/getJCKB',
            )
            setJcbk(data)
        } catch (error) {
            throw new Error(error)
        }
    }


    const [yjcg, setYjcg] = useState()
    const getYJCG = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/index/getYJCG',
            )
            setYjcg(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [xxfb, setXxfb] = useState()
    const getXXFB = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/index/getXXFB',
            )
            setXxfb(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [rdzz, setRdzz] = useState()
    const getRDZZ = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/index/getRDZZ',
            )
            setRdzz(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [otherColumn, setOtherColumn] = useState()
    const getOtherColumn = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/index/getOtherColumn',
            )
            setOtherColumn(data)
            console.log(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    useEffect(() => {
        getSYTJ()
        getJCKB()
        getYJCG()
        getXXFB()
        getRDZZ()
        getOtherColumn()
    }, [])

    const showAuthors = (author_list) => {
        if (author_list.length < 4) {
            return author_list.join('，')
        } else {
            return author_list.slice(0, 3).join('，') + '......'
        }
    }

    return (
        <Layout className={style.index}>
            <Header className={style.index__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.index__wapper}>
                <Flex vertical={true} className={style.index__wapper__one}>
                    <Flex className={style.index__wapper__one__title}>科技期刊出版智库</Flex>
                    <Flex className={style.index__wapper__one__info}>打造数据驱动的科技期刊出版智库。把握全球出版态势、引领技术前沿、创新评价体系、维护科研诚信，为我国建设世界一流科技期刊提供决策支撑。</Flex>
                    <Flex><Button onClick={() => toGo('/about')} className={style.index__wapper__one__btn}>了解更多</Button></Flex>
                </Flex>
                {((sytj !== undefined) && (sytj.data.length > 0)) && <Flex vertical={false} className={style.index__wapper__two}>
                    <Flex vertical={false}>
                        {(Object.keys(sytj.left).length > 0) && <a target="_blank" href={sytj.left.url}>
                            <Flex style={{
                                backgroundImage: `url(${REQUEST_URL}/upload/img/${sytj.left.image_url}.jpg)`
                                , backgroundSize: '100% auto'
                            }} justify='flex-start' align='flex-end' className={style.index__wapper__two__img_left}>
                                <div className={style.index__wapper__title_overflow}>
                                    {sytj.left.title}
                                </div>
                            </Flex>
                        </a>}
                        <Flex vertical={true}>
                            {(Object.keys(sytj.right_top).length > 0) && <a target="_blank" href={sytj.right_top.url}>
                                <Flex style={{
                                    backgroundImage: `url(${REQUEST_URL}/upload/img/${sytj.right_top.image_url}.jpg)`
                                    , backgroundSize: '100% auto'
                                }} justify='flex-start' align='flex-end' className={style.index__wapper__two__img_right_top}>
                                    <div className={style.index__wapper__title_overflow}>
                                        {sytj.right_top.title}
                                        {/* fasdfasdfs sfjksadjfljsadfs adjfklasdjflksjd flkjaslfk jlaksjflkjaflkjskl */}
                                    </div>
                                </Flex>
                            </a>}
                            {(Object.keys(sytj.right_bottom).length > 0) && <a target="_blank" href={sytj.right_bottom.url}>
                                <Flex style={{
                                    backgroundImage: `url(${REQUEST_URL}/upload/img/${sytj.right_bottom.image_url}.jpg)`
                                    , backgroundSize: '100% auto'
                                }} justify='flex-start' align='flex-end' className={style.index__wapper__two__img_right_bottom}>
                                    <div className={style.index__wapper__title_overflow}>
                                        {sytj.right_bottom.title}
                                    </div>
                                </Flex>
                            </a>}
                        </Flex>
                    </Flex>
                    <Flex vertical={true} className={style.index__wapper__two__right}>
                        {sytj.data.map((item, index) => {
                            return (<div key={index} style={{ fontSize: '14px', lineHeight: '16px', padding: '12px 0', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                <a target="_blank" href={item.url}>{item.title}</a>
                            </div>)
                        })}
                    </Flex>
                </Flex>}
                {(jckb !== undefined && jckb.data.length > 0) && <Flex vertical={false} align='center' className={style.index__wapper__three}>
                    <Flex vertical={true} className={style.index__wapper__three__left}>
                        <Flex>
                            <Flex justify='center' align='center' shape="circle" className={style.index__wapper__three__icon}>
                                <NewspaperFolding theme="outline" size="20" fill="#2267fa" />
                            </Flex>
                        </Flex>
                        <Flex className={style.index__wapper__three__title}>
                            科技出版动态监测快报
                        </Flex>
                        <Flex className={style.index__wapper__three__info}>
                            持续监测国内外科技期刊出版的发展态势，准确研判世界一流科技期刊的前沿动向。
                        </Flex>
                        <Flex className={style.index__wapper__three__more}>
                            <a onClick={() => toGo('/jckb')}>查看更多 →</a>
                        </Flex>
                    </Flex>
                    <Flex vertical={false} className={style.index__wapper__three__right} wrap justify='space-between'>
                        {jckb.data.map((item, index) => {
                            return (
                                <Flex key={index} vertical={false} justify='space-between' className={style.index__wapper__three__before}>
                                    <Flex vertical={true} className={style.index__wapper__three__item} >
                                        <div><a target='_blank' href={`./detail?show=jckb&id=${item.id}`}>{item.title}</a></div>
                                        <div className={style.index__wapper__three__issue}><a href={`./jckb?year=${item.year}&issue=${item.issue}`}>{item.year}年{item.issue}期</a></div>
                                    </Flex>
                                </Flex>
                            )
                        })}
                    </Flex>
                </Flex>}
                <Flex vertical={false} className={style.index__wapper__four}>
                    <Flex vertical={true} className={style.index__wapper__four__left}>
                        <Flex vertical={false} justify='space-between' className={style.index__wapper__four__top}>
                            <Flex className={style.index__wapper__four__title}>
                                {yjcg !== undefined ? yjcg.title : '学术研究成果'}
                            </Flex>
                            <Flex onClick={() => toGo('/kycg')} className={style.index__wapper__four__more}>
                                查看更多
                            </Flex>
                        </Flex>
                        <Flex vertical={false} justify='space-between' className={style.index__wapper__four__content}>
                            {(yjcg !== undefined && yjcg.data.length > 3) && <Flex justify='space-between' vertical={true} className={style.index__wapper__four__content__left}>
                                <Flex vertical={false}>
                                    <Flex className={style.index__wapper__four__img}><img width={144} height={80} src='http://121.36.15.129:8082/api/v1/upload/img/2.jpg' /></Flex>
                                    <Flex justify='space-between' className={style.index__wapper__four__img__title} vertical={true}>
                                        <Flex className={style.index__wapper__four__img__title__title}><a target='_blank' href={(yjcg.data[0].isUp && yjcg.data[0].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[0].id}` : yjcg.data[0].url}>{yjcg.data[0].title}</a></Flex>
                                        <Flex className={style.index__wapper__four__img__title__date}>{yjcg.data[0].pub_date}</Flex>
                                        <Flex className={style.index__wapper__four__img__title__editor}>{showAuthors(yjcg.data[0].authors)}</Flex>
                                    </Flex>
                                </Flex>
                                <Flex vertical={false}>
                                    <Flex className={style.index__wapper__four__img}><img width={144} height={80} src='http://121.36.15.129:8082/api/v1/upload/img/3.jpg' /></Flex>
                                    <Flex justify='space-between' className={style.index__wapper__four__img__title} vertical={true}>
                                        <Flex className={style.index__wapper__four__img__title__title}><a target='_blank' href={(yjcg.data[1].isUp && yjcg.data[1].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[1].id}` : yjcg.data[1].url}>{yjcg.data[1].title}</a></Flex>
                                        <Flex className={style.index__wapper__four__img__title__date}>{yjcg.data[1].pub_date}</Flex>
                                        <Flex className={style.index__wapper__four__img__title__editor}>{showAuthors(yjcg.data[1].authors)}</Flex>
                                    </Flex>
                                </Flex>
                                <Flex vertical={false}>
                                    <Flex className={style.index__wapper__four__img}><img width={144} height={80} src='http://121.36.15.129:8082/api/v1/upload/img/4.jpg' /></Flex>
                                    <Flex justify='space-between' className={style.index__wapper__four__img__title} vertical={true}>
                                        <Flex className={style.index__wapper__four__img__title__title}><a target='_blank' href={(yjcg.data[2].isUp && yjcg.data[2].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[2].id}` : yjcg.data[2].url}>{yjcg.data[2].title}</a></Flex>
                                        <Flex className={style.index__wapper__four__img__title__date}>{yjcg.data[2].pub_date}</Flex>
                                        <Flex className={style.index__wapper__four__img__title__editor}>{showAuthors(yjcg.data[2].authors)}</Flex>
                                    </Flex>
                                </Flex>
                            </Flex>}

                            {(yjcg !== undefined && yjcg.data.length > 4) && <Flex vertical={true} justify='space-between'>
                                {yjcg.data[3] && <Flex vertical={false} className={style.index__wapper__four__before}>
                                    <Flex vertical={true} className={style.index__wapper__four__item} justify='center'>
                                        <div className={style.index__wapper__div_two_line} style={{ height: 40, overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}><a target='_blank' href={(yjcg.data[3].isUp && yjcg.data[3].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[3].id}` : yjcg.data[3].url}>{yjcg.data[3].title}</a></div>
                                        <div className={style.index__wapper__four__data_editor}>{yjcg.data[3].pub_date} | {showAuthors(yjcg.data[3].authors)}</div>
                                    </Flex>
                                </Flex>}
                                {yjcg.data[4] && <Flex vertical={false} className={style.index__wapper__four__before}>
                                    <Flex vertical={true} className={style.index__wapper__four__item} justify='center'>
                                        <div className={style.index__wapper__div_two_line} style={{ height: 40, overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}><a target='_blank' href={(yjcg.data[4].isUp && yjcg.data[4].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[4].id}` : yjcg.data[4].url}>{yjcg.data[4].title}</a></div>
                                        <div className={style.index__wapper__four__data_editor}>{yjcg.data[4].pub_date} | {showAuthors(yjcg.data[4].authors)}</div>
                                    </Flex>
                                </Flex>}
                                {yjcg.data[5] && <Flex vertical={false} className={style.index__wapper__four__before}>
                                    <Flex vertical={true} className={style.index__wapper__four__item} justify='center'>
                                        <div className={style.index__wapper__div_two_line} style={{ height: 40, overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}><a target='_blank' href={(yjcg.data[5].isUp && yjcg.data[5].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[5].id}` : yjcg.data[5].url}>{yjcg.data[5].title}</a></div>
                                        <div className={style.index__wapper__four__data_editor}>{yjcg.data[5].pub_date} | {showAuthors(yjcg.data[5].authors)}</div>
                                    </Flex>
                                </Flex>}
                                {yjcg.data[6] && <Flex vertical={false} className={style.index__wapper__four__before}>
                                    <Flex vertical={true} className={style.index__wapper__four__item} justify='center'>
                                        <div className={style.index__wapper__div_two_line} style={{ height: 40, overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}><a target='_blank' href={(yjcg.data[6].isUp && yjcg.data[6].isUp === '是') ? `./detail?show=yjcg&id=${yjcg.data[6].id}` : yjcg.data[6].url}>{yjcg.data[6].title}</a></div>
                                        <div className={style.index__wapper__four__data_editor}>{yjcg.data[6].pub_date} | {showAuthors(yjcg.data[6].authors)}</div>
                                    </Flex>
                                </Flex>}
                            </Flex>}
                        </Flex>
                    </Flex>
                    <Flex vertical={true} className={style.index__wapper__four__right}>
                        <Flex vertical={false} justify='space-between' className={style.index__wapper__four__top}>
                            <Flex className={style.index__wapper__four__title}>
                                {xxfb !== undefined ? xxfb.title : '信息发布'}
                            </Flex>
                            <Flex onClick={() => toGo('/xxfb')} className={style.index__wapper__four__more}>
                                查看更多
                            </Flex>
                        </Flex>
                        {(xxfb !== undefined) && <Flex vertical={true} justify='space-between' className={style.index__wapper__four__right__content}>
                            {xxfb.data.map((item, index) => {
                                return (
                                    <Flex key={index} vertical={false}>
                                        <Flex justify='center' align='center' className={style.index__wapper__four__right__content__icon}>
                                            <VolumeSmall style={{ paddingLeft: '3px', paddingTop: '3px' }} theme="outline" size="18" fill="#2267fa" />
                                        </Flex>
                                        <Flex vertical={true} className={style.index__wapper__four__right__content__info}>
                                            <div className={style.index__wapper__div_two_line} style={{ height: 35, overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}><a target='_blank' href={(item.isUp === '是') ? `./detail?show=xxfb&id=${item.id}` : item.url}>{item.title}</a></div>
                                            <div className={style.index__wapper__four__data_editor}>{item.pub_date}</div>
                                        </Flex>
                                    </Flex>
                                )
                            })}
                        </Flex>}
                    </Flex>
                </Flex>
                {(rdzz !== undefined && rdzz.data.length > 0) && <Flex vertical={true} className={style.index__wapper__five}>
                    <Flex justify='space-between' className={style.index__wapper__five__top}>
                        <Flex className={style.index__wapper__five__top__title}>
                            {rdzz.title}
                        </Flex>
                        <Flex onClick={() => toGo('/qqrd')} className={style.index__wapper__five__top__more}>
                            查看更多
                        </Flex>
                    </Flex>
                    <Flex justify='space-between' className={style.index__wapper__five__content} wrap>
                        {rdzz.data.map((item, index) => {
                            return (
                                <Flex key={index} vertical={false} className={style.index__wapper__five__before}>
                                    <Flex vertical={true} className={style.index__wapper__five__item} >
                                        <div className={style.index__wapper__five__title}><a target='_blank' href={item.url}>{item.title}</a></div>
                                        <div className={style.index__wapper__five__issue}>{item.pub_date} ｜ {item.source}</div>
                                    </Flex>
                                </Flex>
                            )
                        })}
                    </Flex>
                </Flex>}

                {otherColumn !== undefined && otherColumn.column.map((title, index) => {
                    return (
                        <Flex key={index} vertical={true} className={style.index__wapper__five}>
                            <Flex justify='space-between' className={style.index__wapper__five__top}>
                                <Flex className={style.index__wapper__five__top__title}>
                                    {title}
                                </Flex>
                            </Flex>
                            <Flex justify='space-between' className={style.index__wapper__five__content} wrap>
                                {otherColumn.data[title].map((item, index) => {
                                    return (
                                        <Flex key={index} vertical={false} className={style.index__wapper__five__before}>
                                            <Flex vertical={true} className={style.index__wapper__five__item} >
                                                <div className={style.index__wapper__five__title}><a target='_blank' href={item.url}>{item.title}</a></div>
                                                <div className={style.index__wapper__five__issue}>{item.pub_date} ｜ {item.author}</div>
                                            </Flex>
                                        </Flex>
                                    )
                                })}
                            </Flex>
                        </Flex>
                    )
                })}

            </Content>
            <Footer className={style.index__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    );
}

export default IndexMy;
